// extracted by mini-css-extract-plugin
module.exports = {"container":"sharedHistoryDialog_container__28lRS","title":"sharedHistoryDialog_title__3ZVO4","inputContainer":"sharedHistoryDialog_inputContainer__1fc8z","iconCopy":"sharedHistoryDialog_iconCopy__2noHf","text":"sharedHistoryDialog_text__14GZy","tooltip":"sharedHistoryDialog_tooltip__2JV0Z"};
    if(module.hot) {
      // 1783592059208
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  